import type {
  PatchPlatformV1UsersIdBody,
  PlatformUser,
  PostPlatformV1UsersBody,
} from '@nucleus-commerce/api-client/platform';

import type { CreateUserOutput } from '../schemas/create-user-schema';
import type { EditUserOutput } from '../schemas/edit-user-schema';

export function toCreateUserRequest(values: CreateUserOutput): PostPlatformV1UsersBody {
  return { email: values.email, name: values.name, role: values.role };
}

/** Only what changed goes on the wire: the backend rejects role/status edits on yourself even when unchanged. */
export function toUpdateUserRequest(
  user: PlatformUser,
  values: EditUserOutput,
): PatchPlatformV1UsersIdBody {
  return {
    ...(values.name !== user.name ? { name: values.name } : {}),
    ...(values.role !== user.role ? { role: values.role } : {}),
    ...(values.status !== user.status ? { status: values.status } : {}),
  };
}
